import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../../../Button';
import { cn } from '../../../../../utils/cn';

interface AuthErrorDisplayProps {
  error: string;
  errorType: 'error' | 'warning';
  recoverySuggestions: string[];
  showLoginSuggestion: boolean;
  showResendVerification: boolean;
  resendingVerification: boolean;
  onTryLogin: () => void;
  onResendVerification: () => Promise<void>;
}

export const AuthErrorDisplay: React.FC<AuthErrorDisplayProps> = ({
  error,
  errorType,
  recoverySuggestions,
  showLoginSuggestion,
  showResendVerification,
  resendingVerification,
  onTryLogin,
  onResendVerification,
}) => {
  if (!error) return null;

  return (
    <div className={cn(
      "p-3 rounded-lg text-sm border",
      errorType === 'warning'
        ? "bg-yellow-50 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-200 border-yellow-300 dark:border-yellow-700"
        : "bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-200 border-red-300 dark:border-red-700"
    )}>
      <p className="font-medium text-center">{error}</p>

      {recoverySuggestions.length > 0 && (
        <ul className="mt-2 ml-4 list-disc text-xs space-y-1">
          {recoverySuggestions.map((suggestion, i) => (
            <li key={i}>{suggestion}</li>
          ))}
        </ul>
      )}

      {showLoginSuggestion && (
        <div className="mt-3 flex justify-center">
          <Button
            onClick={onTryLogin}
            variant="outline"
            size="sm"
            className="font-medium"
          >
            Try Login Instead
          </Button>
        </div>
      )}

      {showResendVerification && (
        <div className="mt-3 flex justify-center">
          <Button
            onClick={onResendVerification}
            variant="outline"
            size="sm"
            disabled={resendingVerification}
            className="font-medium"
          >
            {resendingVerification ? (
              <>
                <Loader2 className="h-3 w-3 animate-spin mr-2" />
                Sending...
              </>
            ) : (
              'Resend Verification Email'
            )}
          </Button>
        </div>
      )}
    </div>
  );
};
